﻿import React from "react";
import ReactLoading from "react-loading";

function Loading(props) {
    return (
        <div className={"loadingcontainer"}>
            <ReactLoading type="spin" color="#F34255" height={60} width={60} />
            <div>{props.loadingtext}</div>
        </div>
    );
}

export default Loading;
